export class PickedBinItemModel {
    pickListItemId?: number;
    orderId?: number;
    warehouseCartBinId: number;
    quantity: number;
}
